module.exports = __webpack_public_path__ + "files/SPIADI2020.2b1fbb221cff4a35573d748b2604fb41.zip";